<template>
    <section class="b-gallery">

        <figure class="b-gallery-big">
            <span class="b-gallery__preview-icon">
                <i class="fas fa-search"></i>
            </span>
            <img :src="bigImage"/>
        </figure>
       <ul class="b-gallery-list clean-list">
           <li class="b-gallery-list__item" v-for="(item, index) in media" :class="{ 'b-gallery-list__item--active': index === activeItem}" @click.prevent="setBigImage(index)">
               <img :src="item.thumb" />
           </li>
       </ul>
    </section>
</template>
<script>
    export default {
        props:['media'],
        data() {
            return {
                bigImage: "",
                activeItem: 0,
            }
        },
        methods: {
            setBigImage(index) {
                this.activeItem = index;
                this.bigImage = this.media[index].big;
            }
        },
        mounted() {
            this.bigImage = this.media[0].big;
        }
    }
</script>
